export default (profilingConsent) => {
  const isBool = typeof profilingConsent === 'string' && (profilingConsent.toLowerCase() === 'true' || profilingConsent.toLowerCase() === 'false')
  if ((typeof profilingConsent === 'string' && !isBool) || profilingConsent === undefined) {
    return null
  }
  return JSON.parse(profilingConsent)
}
